import React, { useEffect, useState } from 'react';
import DataTable from '../../components/DataTablePtBr';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import api from '../../services/api';
import { showError, showSuccess, showConfirmation } from '../../services/alert';

const SafraList = () => {
  const [safras, setSafras] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchSafras = async () => {
    setLoading(true);
    try {
      const res = await api.get('/safras');
      setSafras(res.data);
    } catch (err) {
      console.error('Erro ao buscar safras:', err);
      showError('Erro ao buscar safras.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSafras();
  }, []);

  const handleDelete = async (id) => {
    const confirmou = await showConfirmation({
      title: 'Excluir safra?',
      text: 'Essa ação não pode ser desfeita.',
      confirmText: 'Sim, excluir',
      cancelText: 'Cancelar',
    });
    if (!confirmou) return;

    try {
      await api.delete(`/safras/${id}`);
      showSuccess('Safra excluída com sucesso.');
      fetchSafras();
    } catch (err) {
      console.error('Erro ao excluir safra:', err);
      showError('Erro ao excluir safra.');
    }
  };

  const columns = [
    { name: 'Safra', selector: row => row.descricao || '-', sortable: true },
    { name: 'Cultura', selector: row => row.cultura, sortable: true },
    { name: 'Área (ha)', selector: row => row.areaHa, sortable: true },
    
    { name: 'Data do plantio', selector: row => new Date(row.dataPlantio).toLocaleDateString(), sortable: true },
    {
      name: 'Ações',
      cell: row => (
        <div className="d-flex gap-1">
          <button
            className="btn btn-outline-success btn-sm"
            onClick={() => navigate(`/safras/editar/${row.id}`)}
          >
            <i className="bi bi-pencil-square"></i> Editar
          </button>
          <button
            className="btn btn-outline-danger btn-sm"
            onClick={() => handleDelete(row.id)}
          >
            <i className="bi bi-trash"></i> Excluir
          </button>
        </div>
      ),
      ignoreRowClick: true,
    },
  ];

  return (
    <div className="container mt-4">
      <Header />
      <div className="card shadow-lg border-0 rounded-3">
        <div className="card-header bg-success text-white d-flex justify-content-between align-items-center rounded-top-3">
          <div className="d-flex align-items-center gap-3">
            <button
              className="btn btn-light btn-sm d-flex align-items-center gap-1"
              onClick={() => navigate('/menu')}
              disabled={loading}
            >
              <i className="bi bi-arrow-left text-success"></i>
              <span className="text-success fw-semibold">Voltar</span>
            </button>
            <div>
              <h5 className="mb-0">Safras</h5>
              <small className="text-white-50">Gerencie os ciclos de cultivo</small>
            </div>
          </div>
          <button
            className="btn btn-light text-success fw-bold"
            onClick={() => navigate('/safras/create')}
          >
            <i className="bi bi-plus-circle"></i> Nova Safra
          </button>
        </div>
        <div className="card-body">
          <DataTable
            columns={columns}
            data={safras}
            pagination
            responsive
            highlightOnHover
            striped
            progressPending={loading}
            noDataComponent={<div className="text-muted">Nenhuma safra encontrada.</div>}
          />
        </div>
      </div>
    </div>
  );
};

export default SafraList;
